export default __webpack_public_path__ + "static/media/stocks-graphic.c4d4a141.jpeg";